import {MouseEventHandler} from "react";
import SpinnerIcon from "../../icons/SpinnerIcon";

export function LoadingPanel(props: { text: string, onClick?: MouseEventHandler | undefined; }) {
    return (
        <div><SpinnerIcon/> {props.text}</div>
    )
}